import { startPinyinChart } from "./pinyin-chart-tool.js";
import { startTools } from "./start-tools.js";

/**
 * The bundle for the pinyin chart.
 *
 * Its own, because the chart reads no dictionary and converts nothing. The
 * data is in the page and the recordings are files, so this is the smallest
 * of the tool bundles.
 */
startTools(document, new Map([["pinyin-chart", startPinyinChart]]));
